var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: _vm.transitionName, appear: "" },
      on: { enter: _vm.handleEnter, leave: _vm.handleLeave }
    },
    [
      _c(
        "div",
        { class: _vm.classes, style: _vm.styles },
        [
          _vm.type === "notice"
            ? [
                _c("div", {
                  ref: "content",
                  class: _vm.contentClasses,
                  domProps: { innerHTML: _vm._s(_vm.content) }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.contentWithIcon },
                  [_c("render-cell", { attrs: { render: _vm.renderFunc } })],
                  1
                ),
                _vm._v(" "),
                _vm.closable
                  ? _c(
                      "a",
                      {
                        class: [_vm.baseClass + "-close"],
                        on: { click: _vm.close }
                      },
                      [_c("i", { staticClass: "ivu-icon ivu-icon-ios-close" })]
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "message"
            ? [
                _c(
                  "div",
                  { ref: "content", class: _vm.messageContentClasses },
                  [
                    _c("div", {
                      class: [_vm.baseClass + "-content-text"],
                      domProps: { innerHTML: _vm._s(_vm.content) }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: [_vm.baseClass + "-content-text"] },
                      [
                        _c("render-cell", { attrs: { render: _vm.renderFunc } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.closable
                      ? _c(
                          "a",
                          {
                            class: [_vm.baseClass + "-close"],
                            on: { click: _vm.close }
                          },
                          [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-ios-close"
                            })
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-032e12d8", { render: render, staticRenderFns: staticRenderFns })
  }
}